import React, { Component } from 'react';
import yaml from 'js-yaml';

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import WordSec from '../components/WordSec'
import WordBtn from '../components/WordBtn'
import ListSec from '../components/ListSec'
import SlideShow from '../components/SlideShow'
import PicWordSec from '../components/PicWordSec'
import WordPicSec from '../components/WordPicSec'
import SelfIntro from '../components/SelfIntro'
import NewsItem from '../components/NewsItem'
import FiveWItem from '../components/FiveWItem'
import PartnerSec from '../components/PartnerSec'
import PicDisplay from '../components/PicDisplay'
import IconWord from '../components/IconWord'
import SmallWordPicSec from '../components/SmallWordPicSec'
import TopPicDownWordSec from '../components/TopPicDownWordSec'
import VideoGallery from '../components/VideoGallery'
import SpecItem from '../components/SpecItem'



import '../css/old_web.css';
import '../css/TechPage.css';
import { setCookie, getCookie } from '../utils/cookie_utils.js'


class TechPage extends Component {

  constructor(props) {
    super(props);

    const searchParams = new URLSearchParams(window.location.search);

    var lang = "zh"
    if (getCookie("lang") !== "") {
      lang = getCookie("lang")
    }

    this.state = {
      id: searchParams.get("page"),
      lang: lang,
      tech_page_icon_flag: true,
      tech_page_flag: false,
      tech_page_title: {"en": [], "zh": []},
      tech_page_desc: {"en": [], "zh": []},
      tech_page_img: [],
      readMoreText: {"en": "Read More", "zh": "閱讀更多", "ja": "続きを読む"},
      web_content: {"": []},
      product: [],
      switch_page_flag: false,
    }

    this.get_data = this.get_data.bind(this)
    this.general_switch_page = this.general_switch_page.bind(this)
    this.update_lang = this.update_lang.bind(this)
  }

  componentDidMount() {
    this.get_data(this.state.id)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  update_lang(current_lang) {
    this.setState({
      lang: current_lang
    }, () => {
      console.log(this.state.lang)
    })
  }

  openInNewTab(url) {
        var win = window.open(url, '_blank');
        if (win != null) {
            win.focus();
        }
  }

  general_switch_page(path, data) {
    if (path !== "/GeneralPage" || path !== "/") {
      setCookie("lang", this.state.lang)
      window.location.href = path + "?page=" + data
    }
    else {
      // pass
    }
  }


  render() {

        return (
            <div id="body">
              <Navbar lang={this.state.lang} updateLangFunc={this.update_lang} />

              <div className="tech_section">
                {/*{this.state.tech_page_flag ? <SlideShow lang={this.state.lang} title={this.state.tech_page_title[this.state.lang]} content={this.state.tech_page_desc[this.state.lang]} action={[""]} img={this.state.tech_page_img} img_num={(this.state.tech_page_img).length.toString()} arrow_flag={this.state.tech_page_icon_flag} logo_flag={this.state.tech_page_icon_flag}/> : <></>}*/}
                
                {/*<div className="tech_nav">
                  {this.state.tag[this.state.lang].map((tag, i) => (
                    <button key={i}><a className={this.state.tag["link"][i] === this.state.current_tag ? "clicked" : ""} href={"/TechPage/" + this.props.match.params.id + "/" + this.state.tag["link"][i]}>{tag}</a></button>
                  ))}
                </div>*/}

                <div className="tech_bannar">
                  <img src={"/assets/mainpage_nexuni_white_icon.png"}/>
                  <div className="tech_title_section">
                    <h1>{this.state.tech_page_title[this.state.lang]}</h1>
                    <p>{this.state.tech_page_desc[this.state.lang]}</p>
                  </div>
                </div>

                {Object.keys(this.state.web_content).map((key_name, i) => (
                <div key={i} className={"main_section no_padding_top display_flex"} id={key_name}>
                  {this.state.web_content[key_name].map((item, index) => {
                    if (item["type"] === "tech_intro") {
                      return (<div className="tech_intro">
                          <div className="tech_intro_img" style={{backgroundImage: 'url('+item["img"]+')'}}>
                            
                          </div>
                          <div className="tech_intro_content">
                            <img src={"/assets/mainpage_nexuni_white_icon.png"}/>
                            <h3 dangerouslySetInnerHTML={{__html: item["content"][this.state.lang]}} />
                          </div>
                        </div>)
                    }

                    else if (item["type"] === "tech_cus_and_ps") {
                      return (<div className="tech_cus_and_ps">
                          <div className="tech_cus">
                            <h3>{item["title_cus"][this.state.lang]}</h3>
                            <h4 dangerouslySetInnerHTML={{__html: item["content_cus"][this.state.lang]}} />
                          </div>
                          <div className="tech_ps">
                            <h3>{item["title_ps"][this.state.lang]}</h3>
                            <h4 dangerouslySetInnerHTML={{__html: item["content_ps"][this.state.lang]}} />
                          </div>
                        </div>)
                    }




                    if (item["type"] === "word_section") {
                      return (<WordSec key={index} className="general_section" title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} style={item["style"]} />)
                    }
                    else if (item["type"] === "video_gallery") {
                      return (<VideoGallery key={index} className="general_section" video_link={item["video_link"]} />)
                    }
                    else if (item["type"] === "word_btn") {
                      return (<WordBtn key={index} action={item["action"]} className="general_section" title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} style={item["style"]} />)
                    }
                    else if (item["type"] === "list_section") {
                      return (<ListSec key={index} className="general_section" title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} main_title={item["main_title"][this.state.lang]} />)
                    }

                    else if (item["type"] === "slide_show") {
                      return (<SlideShow lang={this.state.lang} key={index} title={item["title"]} content={item["content"]} action={item["action"]} img={item["img"]} img_num={item["img_num"]} logo_flag={false}/>)
                    }

                    else if (item["type"] === "top_pic_down_word_section") {
                      return (
                        <div key={index} className="two_item_holder">
                          {item["img"].map((img_src, tpdw_i) => 
                            <TopPicDownWordSec key={tpdw_i} img={img_src} title={item["title"][this.state.lang][tpdw_i]} content={item["content"][this.state.lang][tpdw_i]} style={item["style"]}/>
                          )}
                        </div>)
                    }

                    else if (item["type"] === "pic_word_section") {
                      var rmtxt = "";
                      if (!Object.values(item).includes("readMoreText")) {
                        rmtxt = item["content"][this.state.lang].length > 300 ? this.state.readMoreText[this.state.lang] : "";
                      }
                      return (<WordPicSec key={index} className="general_section" readMoreText={rmtxt} img={item["img"]} title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} style={item["style"]}/>)
                    }

                    else if (item["type"] === "word_pic_section") {
                      var rmtxt = "";
                      if (!Object.values(item).includes("readMoreText")) {
                        rmtxt = item["content"][this.state.lang].length > 300 ? this.state.readMoreText[this.state.lang] : "";
                      }
                      return (<PicWordSec key={index} className="general_section" readMoreText={rmtxt} img={item["img"]} title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} style={item["style"]}/>)
                    }

                    else if (item["type"] === "small_word_pic_section") {
                      return (<SmallWordPicSec key={index} action={item["action"]} className="general_section" img={item["img"]} title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} style={item["style"]}/>)
                    }

                    else if (item["type"] === "self_intro") {
                      return (<SelfIntro key={index} className="general_section" content={item["content"]} />)
                    }

                    else if (item["type"] === "news_item") {
                      return (<NewsItem key={index} className="general_section" content={item["content"]} />)
                    }

                    else if (item["type"] === "five_w_item") {
                      return (<FiveWItem key={index} className="general_section" title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} />)
                    }

                    else if (item["type"] === "title_section") {
                      return (<div key={index} className="title_section_holder"><h1>{item["title"][this.state.lang]}</h1></div>)
                    }

                    else if (item["type"] === "partner_section") {
                      return (<PartnerSec key={index} img={item["img"]} title={item["title"][this.state.lang]} action={item["action"]}/>)
                    }

                    else if (item["type"] === "pic_display") {
                      return (<PicDisplay key={index} img={item["img"]} title={item["title"][this.state.lang]} style={item["style"]}/>)
                    }

                    else if (item["type"] === "video_display") {
                      return (<iframe key={index} width="100%" height="700px" src={item["video_src"]}></iframe>)
                    }

                    else if (item["type"] === "icon_word") {
                      return (<div key={index}  className="icon_word_holder">
                                {item["title"][this.state.lang].map((title, i) => (<IconWord key={i} style={item["style"]} img={item["img"][i]} title={title}/>))}
                              </div>)
                    }

                    else if (item["type"] === "spec_item") {
                      return (<SpecItem key={index} className="spec_item" lang={this.state.lang} img={item["img"]} title={item["title"]} content={item["content"]} />)
                    }

                  })}
                </div>))}


              </div>
              

              <Footer lang={this.state.lang} general_switch_page={this.general_switch_page} />
      
            </div>
      
        );}



  get_data(page_title) {

    fetch(process.env.PUBLIC_URL + '/yaml/product_info.yaml')
    .then(response => response.text())
    .then(text => {
      const tech_content = yaml.load(text)["tech_content"];
      console.log(tech_content, page_title, tech_content[page_title])
      this.setState({
        tech_page_flag: true,
        tech_page_icon_flag: tech_content[page_title]["tech_page_icon_flag"],
        tech_page_title: tech_content[page_title]["tech_page_title"],
        tech_page_desc: tech_content[page_title]["tech_page_desc"],
        tech_page_img: tech_content[page_title]["tech_page_img"],
        web_content: tech_content[page_title]["web_content"]
      })
    });
  }

}

export default TechPage;
